module.exports = __webpack_public_path__ + "img/english.bbf5842f.svg";